















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class Dialog extends Vue {
  @Prop({ type: String, default: "" }) readonly title!: string;
  @Prop({ type: Boolean, default: false }) readonly visible!: boolean;

  confirm() {
    this.$emit('confirm')
  }

  cancel() {
    this.$emit('cancel')
  }
}
